export enum Banner {
  FeedPersonalizationBanner = 'feed_personalization_banner',
  Nps = 'nps',
  EmailConfirmation = 'email_confirmation',
  RecommendedSearchesViewCount = 'recommended_searches_view_count',
  TermsAndConditions = 'terms_and_conditions',
  PortalMergeSourceAnnouncement = 'portal_merge_source_announcement',
  PortalMergeWelcomeScreen = 'portal_merge_welcome_screen',
  PortalMergeDraftItemsReminder = 'portal_merge_draft_items_reminder',
  ListerActivation = 'lister_activation',
  OnboardingModal = 'onboarding_modal',
  BusinessAccount = 'business_account',
  CatalogRules = 'catalog_rules',
  BeyondFashion = 'beyond_fashion',
}
